import { render } from "./SmartOnboardingDownload.vue?vue&type=template&id=ddf0bd76&scoped=true"
import script from "./SmartOnboardingDownload.vue?vue&type=script&lang=js"
export * from "./SmartOnboardingDownload.vue?vue&type=script&lang=js"

import "./SmartOnboardingDownload.vue?vue&type=style&index=0&id=ddf0bd76&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddf0bd76"]])

export default __exports__